module.exports = __webpack_public_path__ + "img/category-item.e654ce99.png";